import { z } from "zod";
import { IsoDateTime, OpaqueId } from "./common.js";
/**
 * Onglet Véhicules (backlog Phase 2 P2-46/47/48), menu noir à côté de Réseau.
 * Hors régulation : suivi de parc.
 *
 * Un véhicule s'identifie par sa **clé stable** (préfixée flux) ; le numéro de
 * parc (`displayNumber`) reste de l'affichage seul (CDC §6.1). Le flux d'où sa
 * position est décodée détermine son exploitant (décision utilisateur
 * 2026-09-06 : un véhicule d'un flux ne roule jamais pour un autre exploitant).
 * Aucune donnée nominative.
 */
export const VehicleState = z.enum(["online", "offline", "gone"]);
export const VehicleListItem = z.object({
    vehicleId: OpaqueId,
    displayNumber: z.string(),
    operatorId: z.string(), // flux temps réel
    exploitantId: z.string().nullable(), // résolu depuis `config.exploitants[].operatorIds`
    state: VehicleState, // online < vehicleOfflineSeconds ; gone > 24 h ; offline entre les deux
    lastSeenAt: IsoDateTime,
    offlineSince: IsoDateTime.nullable(), // = lastSeenAt quand l'état n'est pas « online »
});
export const VehiclesResponse = z.object({
    vehicles: z.array(VehicleListItem), // du dernier contact au plus récent d'abord
    /**
     * v1.46 (D-020) — opérateurs (flux) effectivement **masqués** pour cette
     * requête : `config.fleetView.hiddenOperatorIds` moins ceux que le `?post=`
     * transmis régule. `[]` si rien n'est masqué (aucun `hiddenOperatorIds`, ou
     * le poste couvre tous les flux techniques). Le front peut afficher « N flux
     * masqués » ou proposer de les réintégrer.
     */
    hiddenOperatorIds: z.array(z.string()),
});
/** Part d'une ligne dans l'activité d'un véhicule (durée + fraction). */
export const VehicleLineShare = z.object({
    lineId: OpaqueId,
    lineCode: z.string(),
    seconds: z.number().int().nonnegative(),
    ratio: z.number().min(0).max(1),
});
export const VehicleAgendaDay = z.object({
    date: z.string(), // YYYY-MM-DD
    activeSeconds: z.number().int().nonnegative(),
    spanSeconds: z.number().int().nonnegative(), // dernier − premier contact du jour
    activityRatio: z.number().min(0).max(1), // activeSeconds / spanSeconds
    lines: z.array(VehicleLineShare),
});
export const VehicleAgendaResponse = z.object({
    vehicleId: OpaqueId,
    displayNumber: z.string(),
    from: z.string(),
    to: z.string(),
    totalActiveSeconds: z.number().int().nonnegative(),
    overallActivityRatio: z.number().min(0).max(1), // cumul activeSeconds / cumul spanSeconds
    byLine: z.array(VehicleLineShare), // cumul sur toute la plage
    days: z.array(VehicleAgendaDay), // du plus récent au plus ancien
});
export const VehicleGanttSegment = z.object({
    lineId: OpaqueId,
    lineCode: z.string(),
    fromSeconds: z.number().int(), // secondes depuis minuit local du jour d'exploitation
    toSeconds: z.number().int(),
});
export const VehicleGanttRow = z.object({
    vehicleId: OpaqueId,
    displayNumber: z.string(),
    segments: z.array(VehicleGanttSegment), // ordre chronologique
});
export const VehicleGanttResponse = z.object({
    date: z.string(), // YYYY-MM-DD
    rows: z.array(VehicleGanttRow), // un par véhicule actif ce jour-là
});
//# sourceMappingURL=vehicles.js.map